import React from "react"

export default function ArrowLeft() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <g clipPath="url(#clip0_772_537)">
        <path d="M8.0291 11.9001L14.8602 4.91148C15.1896 4.57443 15.7238 4.57443 16.0532 4.91148L16.8499 5.7266C17.1788 6.06308 17.1794 6.60842 16.8513 6.94569L11.4376 12.5104L16.8513 18.0751C17.1794 18.4124 17.1788 18.9577 16.8499 19.2942L16.0532 20.1093C15.7237 20.4464 15.1896 20.4464 14.8602 20.1093L8.0291 13.1207C7.69968 12.7836 7.69968 12.2372 8.0291 11.9001Z" fill="#B8BAC2" />
      </g>
      <defs>
        <clipPath id="clip0_772_537">
          <rect width="16.1102" height="17.9965" fill="white" transform="translate(21.4378 4.45508) rotate(90)" />
        </clipPath>
      </defs>
    </svg>
  )
}